/*
  Builder
  The interactive workspace of a form builder
*/

import { Component, HostListener, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { DocumentService, FormService } from '@app/shared/services';
import { ID } from '@datorama/akita';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SelectionModel } from '@angular/cdk/collections';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  encapsulation: ViewEncapsulation.None,
  selector: 'fl-document-search-dialog',
  styleUrls: ['document-search.dialog.scss'],
  templateUrl: 'document-search.dialog.html'
})
// eslint-disable-next-line @angular-eslint/component-class-suffix
export class DocumentSearchDialog implements OnInit {
  dataLoading = false;
  type: string;
  items: any[] = [];
  displayedColumns: string[] = ['select', 'thumbnail', 'title', 'appliesTo'];
  selection = new SelectionModel<any>(true, []);
  q = '';
  scope: string;
  scopeId: string;
  organizationId: ID;

  private debounceId;
  private readonly DEBOUNCE_DELAY: number = 400;

  @HostListener('window:keyup.esc')
  onEscUp(): void {
    this.dialogRef.close();
  }

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<DocumentSearchDialog>,
    public documentService: DocumentService,
    public formService: FormService
  ) {
    this.type = data.type;
    this.scope = data.scope;
    this.scopeId = data.scopeId;
    this.organizationId = data.organizationId;
  }

  ngOnInit() {
    this.getItems(this.q);
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle = (): void => {
    if (this.isAllSelected()) {
      this.selection.clear();
    } else {
      this.items.forEach((row) => this.selection.select(row));
    }
  };

  onNoClick(): void {
    this.dialogRef.close();
  }

  /** Whether the number of selected elements matches the total number of rows. */
  isAllSelected(): boolean {
    const numSelected = this.selection.selected.length;
    const numRows = this.items.length;
    return numSelected === numRows;
  }

  isItemSelected(item: any): boolean {
    return this.selection.isSelected(item);
  }

  onKeyUp(event: any): void {
    if (event.target.value.length < 3 && event.target.value !== '') return;

    let debounceId: NodeJS.Timeout = this.debounceId;
    clearTimeout(debounceId);
    this.debounceId = setTimeout(() => {
      let targetValue: string = event.target.value;
      this.getItems(targetValue);
    }, this.DEBOUNCE_DELAY);
  }

  getItems(q: string): void {
    this.selection.clear();
    this.dataLoading = true;

    if (this.type === 'forms') {
      this.formService.searchForms(this.organizationId, q, this.scope, this.scopeId, true, {
        success: (data) => {
          this.dataLoading = false;
          this.items = data;
        }
      });
    }
  }
}
